import { Hits, InstantSearch } from 'react-instantsearch-hooks-web';
import { SearchIcon, XIcon } from '@heroicons/react/outline';
import {
  m_search_input,
  m_search_wrapper
} from 'Styles/modules/search.module.scss';

import CustomSearchBox from 'Components/Search/CustomSearchBox';
import Head from 'next/head';
import Hit from 'Components/Algolia/Hit';
import Layout from 'Components/Layout';
import MiniCart from 'Components/Cart/MiniCart';
import NavBackButton from 'Components/Headers/NavBackButton';
import { searchClient } from 'utils/searchClient';

export default function MobileSearch() {
  return (
    <Layout className="search">
      <Head>
        <title>Tìm kiếm</title>
      </Head>
      <InstantSearch
        searchClient={searchClient}
        indexName={process.env.ALGOLIA_INDEX_NAME}
      >
        <div className="header-wrapper top-fix">
          <NavBackButton className="text-white" />
          <div className={m_search_wrapper}>
            <SearchIcon className="h-6 w-6 stroke-1" />
            <CustomSearchBox
              className={m_search_input}
              placeholder="Tìm sản phẩm yêu thích"
              resetIconComponent={
                <XIcon className="absolute right-2 top-3 h-5 w-5 stroke-1" />
              }
            />
          </div>
          <div className="ml-2">
            <MiniCart />
          </div>
        </div>
        <Hits className="absolute" hitComponent={Hit} />
      </InstantSearch>
    </Layout>
  );
}
